import Konva from 'konva';
import React from 'react';
import { diffDay } from 'utils/time';
import { DateRange } from "types/global"
import { GraphStyle } from '../types';
import Tooltip from './Tooltip';


function TooltipDay({
	dateRange,
	style,
	...props
}: TooltipDayProps) {
	if (dateRange.end == null || dateRange.start == null || dateRange.end == dateRange.start) return null
	const dateStart = Math.min(dateRange.start, dateRange.end)
	const dateEnd = Math.max(dateRange.start, dateRange.end)
	const labels = [(diffDay(dateEnd, dateStart) + 1).toString()]

	return <Tooltip
		title="Days"
		labels={labels}
		style={style}
		{...props}
	/>
}

export default TooltipDay

type TooltipDayProps = {
	dateRange: DateRange,
	style: GraphStyle,
} & Konva.NodeConfig
